import React from 'react';
import ctrl from 'controllers/cotacao-ctrl';
import utils from 'utils/utils';
import Row from 'components/row';
import Col from 'components/col';
import FormComboBox from 'components/form-combo-box';
import FormInput from 'components/form-input';
import Button from 'components/button';
import Icon from 'components/icon';
import modal from 'utils/modal-service';
import Dialog from 'components/dialog';
import ItemForm from './oferta-item-form';
import moment from 'moment';

module.exports = React.createClass({

  getInitialState(){
    return {

    }
  },

  handleRemoveClick(item){
    modal.show(() => {
      ctrl.removeItemOferta(item);
    },'Excluir item oferta','Confirma exclusão do item "'+item.descricao+'" da oferta',"danger");
  },

  handleEditClick(item){
    var editItem = utils.extend({},item);
    editItem.dtValidadeOferta = moment(editItem.dtValidadeOferta);
    editItem.codEanOri = editItem.codEan;
    if (editItem.dtValidadeProduto) editItem.dtValidadeProduto = moment(editItem.dtValidadeProduto);
    utils.fromNumberToStr(editItem,['embalagem','preco','prazoPagamento','prazoEntrega']);
    this.setState({editItem: editItem});
  },

  handleAddClick(){
    this.setState({editItem: {}});
  },

  componentDidUpdate(){
    if (this.refs.editDialog && !this.dialogVisible) {
      this.refs.editDialog.show();
      setTimeout(this.refs.itemForm.refs.editEan.focus, 200);
      this.dialogVisible = true;
    }
  },

  clearEditItem(){
    delete ctrl.ofertaErrorMessage;
    delete this.dialogVisible;
    this.setState({editItem: undefined});
  },

  saveEditItem(){
    var item = this.state.editItem;
    var self = this;
    if (!item.codEan) {
      ctrl.setOfertaErrorMessage('Código EAN é obrigatório.')
    } else if (!item.descricao) {
      ctrl.setOfertaErrorMessage('A descrição é obrigatória.')
    } else if (!item.unidade) {
      ctrl.setOfertaErrorMessage('A unidade é obrigatória.')
    } else if (isNaN(parseFloat(item.embalagem)) || (parseFloat(item.embalagem) <= 0)) {
      ctrl.setOfertaErrorMessage('Informe a quantidade da embalagem correta.')
    } else if (isNaN(parseFloat(item.preco)) || (parseFloat(item.preco) <= 0)) {
      ctrl.setOfertaErrorMessage('Informe um preço válido.')
    } else if (isNaN(parseFloat(item.prazoPagamento)) || (parseFloat(item.prazoPagamento) <= 0)) {
      ctrl.setOfertaErrorMessage('Informe um prazo de pagamento válido.')
    } else if (isNaN(parseFloat(item.prazoEntrega)) || (parseFloat(item.prazoEntrega) <= 0)) {
      ctrl.setOfertaErrorMessage('Informe um prazo de entrega válido.')
    } else if (!item.dtValidadeOferta) {
      ctrl.setOfertaErrorMessage('A data de validade da oferta é obrigatório.')
    } else if (item.dtValidadeOferta.isBefore(moment(0, "HH")) ) {
      ctrl.setOfertaErrorMessage('Informe uma data de validade igual ou superior a hoje.')
    } else {

      ctrl.saveItemOferta(item).success(() => {
        self.refs.editDialog.hide();
      });

    }

  },

  render(){

    var itens = [];
    var data = ctrl.dadosFornec.ofertas || [];
    var self = this;
    var dialog;
    var isAddDisabled = !(ctrl.data.fornecedor > -1);

    if (ctrl.data.fornecedor == undefined || ctrl.data.fornecedor == -1) {
      return (<div className="well"><span className="erro">Por favor, selecione um fornecedor.</span></div>);
    }

    data.forEach((item,index) => {

      itens.push(<tr key={index}>
        <td>{item.codEan}</td>
        <td>{item.descricao}</td>
        <td className="text-center">{utils.dateToStr(item.dtValidadeOferta)}</td>
        <td className="text-center"><div>
          <Button className="btn-sm" icon="trash" onClick={self.handleRemoveClick.bind(self,item)} />
          <Button style={{marginLeft: 5}}className="btn-sm" icon="pencil" onClick={self.handleEditClick.bind(self,item)} />
        </div></td>
      </tr>);
    });

    if (this.state.editItem) {
      var title = (this.state.editItem.id) ? 'Alterando Item Oferta' : 'Incluindo Item Oferta';
      dialog = <Dialog ref="editDialog"
                       title={title}
                       onModalClose={this.clearEditItem}
                       onConfirm={this.saveEditItem}
                       large={true}>
                  <ItemForm ref="itemForm" item={this.state.editItem} />
               </Dialog>;
    }

    return (
      <div className="panel panel-primary">
        {dialog}
        <div className="panel-heading">
          <div className="container-fluid panel-container">
            <div className="col-xs-3 text-left">
              <h4 className="panel-title abc">
                Itens oferecidos
              </h4>
            </div>
            <div className="col-xs-9 text-right">
              <ul className="pagination panel-pagination">
                <li><button className='btn btn-default btn-sm' onClick={this.handleAddClick} disabled={isAddDisabled}><Icon name="plus"/></button></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="panel-body">
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th className="text-center">Validade Oferta</th>
                <th className="text-center">Ações</th>
              </tr>
              </thead>
              <tbody>
              {itens}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/ofertar/ofertar-itens.js
 **/